var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBloodTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M284.6,15.55a34,34,0,0,0-57.15,0C202.58,53.94,78.62,215.72,78.62,334.63,78.62,432.45,158.21,512,256,512s177.38-79.52,177.38-177.37C433.38,215.72,309.42,53.94,284.6,15.55ZM376.5,275,233.74,417.76a12.4,12.4,0,0,1-17.55,0L135.5,337.07a12.4,12.4,0,0,1,0-17.55L153.05,302a12.42,12.42,0,0,1,17.56,0L225,356.32,341.39,239.89a12.43,12.43,0,0,1,17.56,0l17.55,17.56A12.4,12.4,0,0,1,376.5,275Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodTick);
export default __webpack_public_path__ + "static/media/bloodTick.6a86bbd077ec4b378366628dab09a5cf.svg";
export { ForwardRef as ReactComponent };